export default {"src":"/_next/static/media/learning-task-active-icon.83671bbb.svg","height":14,"width":14};